import React, { useEffect } from 'react';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import { FaRocket, FaBrain, FaBullseye, FaHandshake, FaIndustry, FaChartLine, FaCheckCircle } from "react-icons/fa";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import enterpriseImage11 from '../Assets/Image/enterpriseImage1.jpg';
import enterpriseImage1 from '../Assets/Image/enterpriseImage2.avif';
import enterpriseImage2 from '../Assets/Image/enterpriseimg1.avif';
import { FaStar } from 'react-icons/fa';
import { Helmet } from 'react-helmet';
import AOS from 'aos';
import 'aos/dist/aos.css';
import '../Assets/Css/enterprise.css'
import {
    FaUniversity,
    FaHeartbeat,
    FaShoppingCart,
    FaNetworkWired,
    FaLandmark,
} from "react-icons/fa";

const Enterprise = () => {
    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    const industries = [
        {
            icon: <FaUniversity size={40} className=" me-2" />,
            title: "Banking & Finance",
            description: "Core banking modernization",
        },
        {
            icon: <FaHeartbeat size={40} className=" me-2" />,
            title: "Healthcare",
            description: "EMR integrations & compliance",
        },
        {
            icon: <FaShoppingCart size={40} className=" me-2" />,
            title: "Retail",
            description: "Omnichannel eCommerce experiences",
        },
        {
            icon: <FaNetworkWired size={40} className=" me-2" />,
            title: "Telecom",
            description: "Cloud migration & OSS/BSS systems",
        },
        {
            icon: <FaLandmark size={40} className=" me-2" />,
            title: "Government",
            description: "Citizen services & data platforms",
        },
    ];

    const testimonials = [
        "Trident Software Services transformed our workflow—efficient, intuitive, and scalable.",
        "Their team is not just tech-savvy, but also incredibly supportive and responsive.",
        "We’ve seen a 40% boost in productivity since implementing Trident’s ERP system.",
        "Professionalism and innovation define our experience with Trident. Highly recommended!",
        "From planning to execution, Trident delivered solutions that matched our business vision perfectly.",
    ];

    return (
        <>
            <Helmet>
                <title>Enterprise Solutions | Trident Software Services</title>
                <meta
                    name="description"
                    content="Trident Software Services empowers enterprises with expert talent, scalable solutions, and rapid project delivery. Accelerate digital transformation with a trusted partner."
                />
                <meta
                    name="keywords"
                    content="Enterprise IT, tech staffing, project delivery, digital transformation, software consulting, Trident Software Services"
                />
                <meta name="author" content="Trident Software Services" />
                <link rel="canonical" href="https://tridentsoftwaresolutions.com/enterprise" />
            </Helmet>

            <div className="enterprise-banner3-section d-flex align-items-center justify-content-center">
                <div className="enterprise-banner3-overlay text-center" data-aos="zoom-in">
                    <h2 className="banner1-title mb-3">Empowering Enterprises with Smart Digital Solutions</h2>
                    <p className="banner1-subtitle" data-aos="zoom-in" data-aos-delay="200">
                        Powering business growth through smart, streamlined, and scalable Software Services.
                    </p>

                </div>
            </div>

            {/* Main Section */}

            {/* <div className=" py-5">
                <Container>
                    <Row className='justify-content-center my-4'>
                        <h3 className="fw-bold text-center section-title">
                            Enterprise Solutions
                            <span className="title-decoration mb-2"></span>
                        </h3>
                        <p className="text-muted text-center" style={{ maxWidth: 700 }}>
                            Powering Business Transformation with Trusted Talent & Technology
                        </p>
                    </Row>
                    
                </Container>
            </div> */}



            <div className="py-5">
                <Container>
                    <Row className="justify-content-center my-4">
                        <h3 className="fw-bold text-center section-title">
                            Enterprise Solutions
                            <span className="title-decoration mb-2"></span>
                        </h3>
                        <p className="text-muted text-center" style={{ maxWidth: 700 }}>
                            Powering Business Transformation with Trusted Talent & Technology
                        </p>
                    </Row>

                    {/* Section 1 */}
                    <Row className="align-items-center my-5">
                        <Col md={5} data-aos="zoom-in" className="d-flex justify-content-center align-items-center">
                            <img src={enterpriseImage1} alt="Enterprise Agility" className="aboutimg mb-3" />
                        </Col>
                        <Col md={7} data-aos="zoom-in">
                            {/* <h4 className="fw-bold mb-3">Accelerate Enterprise Agility</h4> */}
                            <h4 className="fw-bold mb-3 text-center text-lg-start">Accelerate Enterprise Agility</h4>

                            <p className="text-muted" style={{textAlign:'justify'}}>
                                At Trident Software Services, we empower enterprises to shift from reactive maintenance to proactive innovation.
                                Our holistic approach blends strategic consulting, agile execution, and intelligent talent deployment to modernize
                                legacy systems, reduce time-to-market, and create long-term value.
                            </p>
                            <p className="text-muted" style={{textAlign:'justify'}}>
                                By aligning people, processes, and technology, we help enterprises stay responsive in dynamic market conditions
                                and deliver digital outcomes at scale. From core IT transformation to cloud-native initiatives, we partner at every level.
                            </p>
                        </Col>
                    </Row>

                    {/* Section 2 */}
                    <Row className="align-items-center my-5 flex-md-row-reverse">
                        <Col md={5} data-aos="zoom-in" className="d-flex justify-content-center align-items-center">
                            <img src={enterpriseImage2} alt="Enterprise Talent Engine" className="aboutimg mb-3" />
                        </Col>
                        <Col md={7} data-aos="fade-right">
                            <h4 className="fw-bold mb-3 text-center text-lg-start">The Talent Engine Behind Your Vision</h4>
                            <p className="text-muted" style={{textAlign:'justify'}}>
                                Whether you're modernizing infrastructure, building cutting-edge platforms, or scaling delivery teams,
                                we connect you with high-caliber professionals who bring both technical depth and business alignment.
                                Our curated talent network includes engineers, architects, analysts, and project leaders matched to your exact needs.
                            </p>
                            <p className="text-muted" style={{textAlign:'justify'}}>
                                We ensure that every expert we place is aligned with your mission, delivery timeline, and enterprise goals—
                                driving measurable impact from day one. With flexible engagement models, our team becomes a seamless extension of yours.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </div>

            <div className="mission-vision-bg py-5">
                <Container>
                    <Row className='justify-content-center my-4'>
                        <h3 className="fw-bold text-center section-title">
                            Key Benefits
                            <span className="title-decoration mb-2"></span>
                        </h3>
                        <p className="text-muted text-center" style={{ maxWidth: 700 }}>
                            Powering Business Transformation with Trusted Talent & Technology
                        </p>
                    </Row>
                    <Row className="text-center justify-content-center align-items-start">

                        <Col md={5} className="column-box" data-aos="zoom-in" data-aos-delay="100">
                            <FaBullseye className="iconmain" />
                            <h4 className="title">Solving the Hard-to-Fill</h4>
                            <p className="text ms-5">
                                <ul className="ps-3 mb-0 values-list text-start">
                                    <li><FaCheckCircle className='list-icon' /> Fast-track hiring for critical projects</li>
                                    <li><FaCheckCircle className='list-icon' /> Domain-aligned tech professionals</li>
                                    <li><FaCheckCircle className='list-icon' /> Flexible engagement models</li>
                                </ul>
                            </p>
                        </Col>

                        <Col md={5} className="column-box middle-box" data-aos="zoom-in" data-aos-delay="200">
                            <FaHandshake className="iconmain" />
                            <h4 className="title">Strategic Partnership That Delivers</h4>
                            <p className="text">
                                We partner with enterprises not just to fill roles, but to drive transformation. Our teams are delivery-focused and aligned with your success metrics from day one.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </div>

            <section>
                <Container>
                    <Row className='justify-content-center my-5'>
                        <h3 className="fw-bold text-center section-title">
                            Why Trident ?
                            <span className="title-decoration mb-2"></span>
                        </h3>
                    </Row>

                    <Row className="mb-4 gy-4">
                        {[
                            { title: "Domain Expertise", text: "We understand enterprise ecosystems — from core IT to innovation-led transformation.", icon: <FaIndustry size={40} className="why-icon" /> },
                            { title: "Precision Hiring", text: "96% of our candidates clear client rounds — we know what fits your enterprise DNA.", icon: <FaBullseye size={40} className="why-icon" /> },
                            { title: "Delivery Focus", text: "Our staffing and delivery teams are outcome-driven — built around your KPIs.", icon: <FaChartLine size={40} className="why-icon" /> },
                            { title: "Trusted by Talent", text: "Our tech professionals grow with you — for long-term project success.", icon: <FaBrain size={40} className="why-icon" /> },
                        ].map(({ title, text, icon }, i) => (
                            <Col md={6} lg={3} xs={6} key={i} >
                                <Card
                                    className=" shadow-lg why-trident "
                                    style={{ transition: "transform 0.3s ease", cursor: "default" }}
                                    onMouseEnter={e => (e.currentTarget.style.transform = "translateY(-8px)")}
                                    onMouseLeave={e => (e.currentTarget.style.transform = "translateY(0)")}
                                    data-aos="zoom-in" data-aos-delay="200"
                                >
                                    <Card.Body>
                                        <div className="mb-2 d-flex align-items-center">{icon}  <Card.Title className="fw-bold fs-5">{title}</Card.Title></div>

                                        <Card.Text>{text}</Card.Text>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Container>

            </section>


            <section className="pt-5 icon-padding-control">
                <div className="d-flex justify-content-center  icon-section experties-icons">
                    <Container>
                        <Row
                            className="text-center section-heading p-4"
                            data-aos="zoom-in"
                            data-aos-delay="200"
                        >
                            <Col>
                                <h3 className="fw-bold text-white section-title">
                                    Industries We Serve
                                    <span className="title-decoration"></span>
                                </h3>
                                <p className="mx-auto" style={{ maxWidth: 600, color: '#ffcc99' }}>
                                </p>
                            </Col>
                        </Row>

                        <Row className="g-4 justify-content-center">
                            {industries.map((feature, index) => (
                                <Col
                                    key={index}
                                    md={3}
                                    className="text-center icon-item d-flex  align-items-center"
                                    data-aos="fade-up" data-aos-delay="100"
                                >
                                    {feature.icon}
                                    <div className='flex-column ms-2'>
                                        <h5 className="mt-3"> {feature.title} </h5>
                                        <p> {feature.description} </p>
                                    </div>

                                </Col>
                            ))}
                        </Row>
                    </Container>
                </div>
            </section>


            <section className="testimonial-carousel-section my-5">
                <div className="container py-3 ">
                    <Row className="align-items-center justify-content-center flex-md-row m-0">
                        <h3 className="fw-bold text-center section-title">
                            Empowering Innovation Through Experience
                            <span className="title-decoration mb-2"></span>
                        </h3>
                        <p className="text-muted mx-auto" style={{ maxWidth: 700 }}>
                            Hear what our clients say about transforming their business with Trident Software Services.
                        </p>
                        <Col xs={12} md={8} className="text-center order-1 order-md-2" data-aos="zoom-in" data-aos-delay="200">

                            <Swiper
                                modules={[Autoplay, Pagination, Navigation]}
                                spaceBetween={30}
                                loop={true}
                                autoplay={{
                                    delay: 5000,
                                    disableOnInteraction: false,
                                }}
                                pagination={{ clickable: true }}
                                navigation={true}
                                className="testimonial-swiper"
                            >
                                {testimonials.map((text, idx) => (
                                    <SwiperSlide key={idx}>
                                        <div className="stars mb-1">
                                            {[...Array(5)].map((_, i) => (
                                                <FaStar key={i} color="#d23f57" />
                                            ))}
                                        </div>
                                        <p className="testimonial-quote">
                                            <span className="quote-mark">“</span>
                                            {text}
                                            <span className="quote-mark">”</span>
                                        </p>
                                        <p className="author-name">Anonymous</p>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </Col>
                    </Row>
                </div>
            </section>


        </>
    );
};

export default Enterprise;
